import * as React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import PreviewCompatibleImage from "./PreviewCompatibleImage";

import Button from "./Button";
import { nanoid } from "nanoid";
import Content, { HTMLContent } from "./Content";
import TrailLogoByName from "./TrailLogoByName";
const TrailBlock = ({
  logo,
  title,
  note,
  display,
  rating,
  afterRating,
  slug,
  gallerySlug,
  mapSlug,
  pickups,
  departures,
  departsFrom,
  videoSlug,
  related,
  price,
  image,
  metaTitle,
}) => {
  const PageContent = HTMLContent || Content;

  if (!isNaN(price)) {
    price = currency(price);
  }

  let bookingSlugs = [];
  bookingSlugs["Slickrock"] =
    "https://www.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/RWqEk";
  bookingSlugs["The Whole Enchilada"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/JyNk8";
  bookingSlugs["The Whole Enchilada Lower Section"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/JyNk8";
  bookingSlugs["Mag 7"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/qzZx0";
  bookingSlugs["Porcupine Rim Classic"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/JyNk8";
  bookingSlugs["Raptor Route"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/XDdRv";
  bookingSlugs["Raptor Route Eagle Eye - Hawks Glide - Falcon Flow"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/XDdRv";
  bookingSlugs["Moab Brands / Bar-M"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/DxNy1";
  bookingSlugs["San Juan Huts"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/jPZYp";

  bookingSlugs["Kokopelli"] =
    "https://book.peek.com/s/6859bbed-0689-4c50-9592-1fb6e0301ada/qxexP";
  bookingSlugs["Kokopelli Trail"] = bookingSlugs["Kokopelli"];

  title = title.trim();

  if (!metaTitle) metaTitle = "Trail";

  let bookingSlug = bookingSlugs[title];
  let imageClass;

  if (!bookingSlug || bookingSlug === "undefined") {
    bookingSlug = "/book-shuttle/";
  }
  let relatedImageClass;
  if (!related || related === "undefined") {
    related = false;
    imageClass = "trail-logo max-img-400 pl-4 ml-4";
    relatedImageClass = "";
  } else {
    relatedImageClass = "trail-logo max-img-200 trail-small";
  }
  imageClass = "trail-logo max-img-400 pl-4 ml-4";

  let trailLinks = (
    <>
      <div className="column ">
        <Button
          title={`Buy Ticket`}
          link={bookingSlug}
          className="link-button-orange is-size-5"
        />
      </div>
      {slug ? (
        <div className="column">
          <Button
            title={`${metaTitle} Info`}
            link={slug}
            className="link-button-gray is-size-5 has-text-weight-normal"
          />
        </div>
      ) : null}
      {mapSlug ? (
        <div className="column">
          <Button
            title={`${metaTitle} Map`}
            link={mapSlug}
            className="link-button-gray is-size-5 has-text-weight-normal"
          />
        </div>
      ) : null}
    </>
  );

  let mediaLinks = (
    <>
      {gallerySlug ? (
        <div className="column">
          <Button
            title="Photos"
            link={gallerySlug}
            className="link-button-gray is-size-5 has-text-weight-normal"
            minimumWidth={200}
          />
        </div>
      ) : null}
      {videoSlug ? (
        <div className="column">
          <Button
            title="Videos"
            link={videoSlug}
            className="link-button-gray is-size-5 has-text-weight-normal"
          />
        </div>
      ) : null}
    </>
  );

  let relatedLinks = (
    <>
      <div className="columns">
        {related &&
          related.length &&
          related.map((rel) => {
            const columnWidth =
              related.length > 3 ? `is-${12 / related.length}` : "is-3";
            return (
              <React.Fragment key={nanoid()}>
                <div className={`column ${columnWidth}`}>
                  <Link to={slug} className="c-inh">
                    <TrailLogoByName
                      name={rel.title}
                      slug={rel.slug}
                      className={relatedImageClass}
                      image={rel.image}
                    />
                  </Link>
                </div>
              </React.Fragment>
            );
          })}
      </div>
    </>
  );

  return (
    <>
      <div className="trail-block">
        <div className="columns mt-2 pt-2 pr-4">
          <div className="column is-3">
            <center>
              <Link to={slug} className="c-inh">
                {logo ? (
                  <>
                    <figure className="image mt-0 pt-0">
                      <PreviewCompatibleImage
                        imageInfo={{
                          image: logo,
                          alt: title,
                          className: `${imageClass}`,
                        }}
                      />
                    </figure>
                  </>
                ) : null}
              </Link>
            </center>
          </div>
          <div className="column is-9 pr-4">
            <Link to={slug} className="c-inh mr-0 pr-0 titling pt-2">
              <h2 className="is-size-1 mb-0 mt-0 pt-0 mr-0 pr-2">
                {image ? (
                  <>
                    <figure className="image mr-0 pr-0">
                      <PreviewCompatibleImage
                        imageInfo={{
                          image: image,
                          alt: title,
                          className: "float-right mr-0 pr-0",
                        }}
                      />
                    </figure>
                  </>
                ) : null}
                {title} <span className="price">{price}</span>
              {note ? (
                <span className="has-text-weight-medium">
                  {note}
                </span>
              ) : null}
              </h2>
            </Link>
            {display ? <div className="mt-c mb-c">{display}</div> : null}
            {rating ? (
              <>
                <PageContent content={rating} className="mt-c mb-c content" />
              </>
            ) : null}
            {afterRating ? (
              <>
                <PageContent content={afterRating} className="mt-c mb-c content" />
              </>
            ) : null}
            <br clear="all" />
            <hr className="gradient" />
            <div>
              <div className="columns is-hidden-desktop">
                <div className="column">
                  <div className="columns">{trailLinks}</div>
                  <div className="columns">{mediaLinks}</div>
                </div>
              </div>

              <div className="is-hidden-touch">
                <div className="columns">
                  {trailLinks}
                  {mediaLinks}
                </div>
              </div>
            </div>
            <div className="content is-hidden-touch">{relatedLinks}</div>
            {pickups && pickups[0] && pickups[0].title === "Private Shuttle" ? (
              <>
                <div className="content">
                  <>
                    * Private Colorado Shuttle -{" "}
                    <em>Departing Locations Vary</em>
                  </>
                  <br />
                </div>
              </>
            ) : (
              <>
                {pickups && pickups.length ? (
                  <>
                    <div className="content">
                      <>* Departing From:</>{" "}
                      {renderDepartures(pickups, departures)}
                      <br />
                    </div>
                  </>
                ) : null}
              </>
            )}
            {departsFrom && departsFrom.length ? (
              <>
                <div className="content">
                  <>* Departing From:</> {departsFrom}
                  <br />
                </div>
              </>
            ) : null}
          </div>
        </div>
        <br />
      </div>
    </>
  );
};

TrailBlock.propTypes = {
  logo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  note: PropTypes.string,
  display: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  rating: PropTypes.string,
  afterRating: PropTypes.string,
  slug: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gallerySlug: PropTypes.string,
  mapSlug: PropTypes.string,
  pickups: PropTypes.array,
  departures: PropTypes.array,
  videoSlug: PropTypes.string,
  related: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.array,
    PropTypes.string,
  ]),
};

export default TrailBlock;

function renderDepartures(pickups, departures) {
  //console.log(pickups);
  //console.log(departures);
  let results = [];
  pickups.forEach((pickup) => {
    if (departures && departures[pickup.title]) {
      let data = departures[pickup.title];
      if (!data.frontmatter.listingSubtitle) {
        data.frontmatter.listingSubtitle = "";
      } else {
        data.frontmatter.listingSubtitle =
          " " + data.frontmatter.listingSubtitle;
      }

      results.push(
        <Link to={data.fields.slug} className="c-inh" key={nanoid()}>
          <em>
            {pickup.title}
            {data.frontmatter.listingSubtitle}
          </em>
        </Link>
      );
    }
  });

  if (results) {
    if (results.length > 1) {
      let last = results.pop();
      return (
        <>
          {results.map((result) => {
            return <React.Fragment key={nanoid()}>{result}, </React.Fragment>;
          })}
          and {last}
        </>
      );
    } else {
      return results;
    }
  } else {
    return null;
  }
}
const currency = function (number) {
  if (
    number !== "Varies" &&
    number !== "Price Varies" &&
    number !== "$NaN" &&
    number !== "$NaN Per Rider" &&
    number
  ) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(number);
  } else {
    return "Price Varies";
  }
};
